import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import adoptionFairs from '@/services/api/adoptionFairs'
import { toast } from 'react-toastify'
import useModalAction from '../useModalAction'

function Close({ fair, onClose }) {
  const [loading, setLoading] = useState(false)
  const { active, close, open } = useModalAction()

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await adoptionFairs.close(fair.id)
      toast.success('Feira encerrada')
      setLoading(false)
      close()
      onClose(data)
    } catch (e) {
      toast.error(e?.message)
      setLoading(false)
    }
  }, [close, fair.id, onClose])

  return (
    <>
      <button type="button" className="btn btn-sm btn-primary mx-1" onClick={open}>
        <i className="fas fa-calendar-check" />
        &nbsp;Encerrar feira
      </button>
      <div className={`modal ${active ? 'active' : ''}`}>
        <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
        <div className="modal-container">
          <div className="modal-header">
            <a
              type="button"
              className="btn btn-clear float-right"
              onClick={close}
            />
            <div className="modal-title h5">
              Encerrar a feira de adoção
            </div>
          </div>
          <div className="modal-body">
            <div className="h3">Atenção</div>
            <p>
              A partir do momento que a feira for encerrada,
              os pets adicionados a ela não poderão mais ser adotados.
            </p>
            <p>
              Você tem certeza que deseja <b>encerrar</b> esta feira de adoção?
              <b><br />{fair?.title}</b>
            </p>
          </div>
          <div className="modal-footer">
            <button
              className={`btn btn-primary ${loading ? 'loading' : ''}`}
              disabled={loading}
              onClick={onConfirm}
              type="button"
            >
              <i className="fas fa-calendar-check" />
              &nbsp;Encerrar feira
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

Close.propTypes = {
  fair: PropTypes.objectOf(Object).isRequired,
  onClose: PropTypes.func,
}

Close.defaultProps = {
  onClose: () => { },
}

export default Close
